import React from 'react'
import CV from '../../assets/David_Darkoh_Resume.pdf'
const CTA = () => {
  return (
    <div className='CTA'>
        <a href={CV} download className= 'btn'>Download Resume</a>
        <a href="#contact" className='btn btn-primary'>Let's Talk</a>
    </div>
  )
}

export default CTA